import { DashboardItemType } from "./dashboard-item-type.enum";
import { GoldenLayoutAdditionMode } from "../../golden-layout/golden-layout-addition-mode";
import { GLPopoutConfiguration } from "../../golden-layout/golden-layout-service";
import { MenuItem } from "@bfx/primeng/api";

export class DashboardMenuItem implements MenuItem {
  id: string;
  label: string;
  icon: string;
  dashboardItemType: DashboardItemType;
  allowMultiples = true;
  command: (event?: any) => void;
  additionMode: GoldenLayoutAdditionMode = GoldenLayoutAdditionMode.DEFAULT;
  items: Array<DashboardMenuItem>;
  glPopoutConfiguration: GLPopoutConfiguration | null;
  separator: boolean = false;
}
